export default "__VITE_ASSET__D54z3MeP__"